import React from 'react'
import PropTypes from 'prop-types'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/pro-light-svg-icons'

import {
  Box,
  Button,
  DashboardModule,
} from '@domain-group/suit-theme'

import useProviderDisclaimer from '@hooks/useProviderDisclaimer'
import useProviderDisclaimers from '@hooks/useProviderDisclaimers'

import DisclaimerListItem from './DisclaimerListItem'

const Disclaimers = (props) => {
  const { providerId } = props

  const providerDisclaimersPayload = useProviderDisclaimers({
    filters: { provider_id: providerId },
    performHttpRequests: !!providerId,
  })

  const {
    filteredProviderDisclaimers,
    hasFilteredProviderDisclaimers,
    loading,
  } = providerDisclaimersPayload

  const providerDisclaimerPayload = useProviderDisclaimer({ provider_id: providerId })
  const {
    callbacks: { createOrEditProviderDisclaimer },
  } = providerDisclaimerPayload

  return (
    <DashboardModule
      boxProps={{ id: 'realhub-nav-disclaimers' }}
      loading={loading}
      title="Disclaimers"
    >
      <Box flexDirection="column">
        {!loading && !hasFilteredProviderDisclaimers && (
          <DashboardModule.BlankState>
            <DashboardModule.BlankState.Title>
              No Disclaimers present
            </DashboardModule.BlankState.Title>

            <DashboardModule.BlankState.Paragraph>
              Please create a Disclaimer below.
            </DashboardModule.BlankState.Paragraph>
          </DashboardModule.BlankState>
        )}

        {!loading && hasFilteredProviderDisclaimers && (
          <DashboardModule.ScrollableSection flexDirection="column">
            {filteredProviderDisclaimers.map(providerDisclaimer => (
              <DisclaimerListItem providerDisclaimer={providerDisclaimer} key={providerDisclaimer.id} />
            ))}
          </DashboardModule.ScrollableSection>
        )}

        <DashboardModule.Footer boxProps={{ borderTop: loading ? 'none' : '1px solid' }}>
          <DashboardModule.FooterRight>
            <Button
              buttonStyle="secondaryEdit"
              icon={<FontAwesomeIcon icon={faPlus} />}
              onClick={() => createOrEditProviderDisclaimer()}
              size={['medium', 'small']}
              width={['100%', 'fit-content']}
            >
              Add Disclaimer
            </Button>
          </DashboardModule.FooterRight>
        </DashboardModule.Footer>
      </Box>
    </DashboardModule>
  )
}

Disclaimers.propTypes = {
  providerId: PropTypes.number.isRequired,
}

export default Disclaimers
